import {
  NEW_AGENTS,
  SELECTED_PAYMENTS,
  VALIDATE_TOKEN,
  VALIDATE_TOKEN_ERROR,
  AGENTS_PENDINGS,
  AGENTS_CATALOGS,
  DELETE_SELECTED_PAYMENTS,
  AGENTS_PAYMENT_REQUEST,
  RESET_SELECTED_PAYMENTS,
  AGENTS_CURRENCY,
  AGENTS_CANCEL,
  RESET_AGENTS_PENDINGS,
  AGENTS_PAYMENT_REQUEST_LOADING,
  AGENTS_PAYMENT_REQUEST_ERROR,
  AGENTS_DOMICILIATION_REQUEST_ERROR,
  SET_AGENTS_FILTER,
  AGENTS_CATALOGS_ERROR,
  RESET_PAYMENT_LOADING,
  RESET_DOMICILIATION_LOADING
} from '../actions/agentActions';

const initialState = {
  page: null,
  selected: [],
  pending: [],
  totalRecordsPending: 0,
  currentRecordsPending: 10,
  totalPagesPending: 0,
  currentPagePending: 1,
  paymentToken: null,
  infoAgent: null,
  error: null,
  catalogCurrencies: [],
  catalogBranches: [],
  catalogOffices: [],
  catalogsError: null,
  currency: 1,
  metadata: null,
  loading: false,
  errorPaymentRequest: null,
  errorDomiciliationRequest: null,
  isFilter: false,
  paymentHistory: {}
}; // END initialState

export default function (state = initialState, action) {
  let { payload } = action;
  switch (action.type) {
    case NEW_AGENTS:
      return { ...state, page: payload };
    case SELECTED_PAYMENTS:
      const updatedSelected = [
        ...state.selected.filter(existingItem => !payload.some(newItem => newItem.invoice === existingItem.invoice)),
        ...payload
      ];
      return { ...state, selected: updatedSelected };
    case RESET_SELECTED_PAYMENTS:
      return { ...state, selected: payload };
    case DELETE_SELECTED_PAYMENTS:
      return {
        ...state,
        selected: payload.length === 0 ? [] : state.selected.filter(item => !payload.includes(item.invoice))
      };
    case AGENTS_PAYMENT_REQUEST:
      return { 
        ...state, 
        loading: false, 
        errorPaymentRequest: null,
        recurringPaymentInfo: payload
      };
    case AGENTS_PAYMENT_REQUEST_ERROR:
      return { ...state, loading: false, errorPaymentRequest: payload };
    case AGENTS_PAYMENT_REQUEST_LOADING:
      return {
        ...state,
        loading: true,
        errorPaymentRequest: null
      };
    case RESET_PAYMENT_LOADING:
      return {
        ...state,
        loading: false,
        errorPaymentRequest: null
      };
    case AGENTS_DOMICILIATION_REQUEST_ERROR:
      return { ...state, loading: false, errorDomiciliationRequest: payload };
    case RESET_DOMICILIATION_LOADING:
      return {
        ...state,
        loading: false,
        errorDomiciliationRequest: null
      };
    case VALIDATE_TOKEN:
      return { ...state, paymentToken: payload.access_token, infoAgent: payload.info, error: null };
    case VALIDATE_TOKEN_ERROR:
      return { ...state, error: payload };
    case AGENTS_PENDINGS:
      return {
        ...state,
        pending: payload.data.map(item => {
          const recurringPayment = 
            item.recurring_payment !== undefined ? item.recurring_payment :
            item.recurringPayment !== undefined ? item.recurringPayment :
            item.recurring !== undefined ? item.recurring :
            0;
          
          return {
            ...item,
            recurring_payment: Number(recurringPayment),
            last_status: item.last_status || null
          };
        }),
        totalRecordsPending: payload.totalRecords,
        currentRecordsPending: payload.currentRecords,
        totalPagesPending: payload.totalPages,
        currentPagePending: payload.currentPage,
        metadata: payload.metadata
      };
    case AGENTS_CURRENCY:
      return {
        ...state,
        currency: payload.data.tipoCambio
      };
    case AGENTS_CATALOGS:
      return {
        ...state,
        catalogCurrencies: payload.data.currencies,
        catalogOffices: payload.data.offices,
        catalogBranches: payload.data.branches,
        catalogsError: null
      };
    case AGENTS_CATALOGS_ERROR:
      return {
        ...state,
        catalogCurrencies: payload.defaultCatalogs.currencies,
        catalogOffices: payload.defaultCatalogs.offices,
        catalogBranches: payload.defaultCatalogs.branches,
        catalogsError: payload.error
      };
    case RESET_AGENTS_PENDINGS:
      return {
        ...state,
        pending: [],
        totalRecordsPending: 0,
        currentRecordsPending: 10,
        totalPagesPending: 0,
        currentPagePending: 1,
        errorPaymentRequest: null,
      };
    case SET_AGENTS_FILTER:
      return{
        ...state,
        isFilter: payload
      }
    case 'SET_PAYMENT_HISTORY':
      return {
        ...state,
        paymentHistory: {
          ...state.paymentHistory,
          [action.payload.uuid]: action.payload.data
        }
      };
    default:
      return state;
  }
} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/agentReducer.js